import styles from "./styles";

const WhiteSpace = ({ height = "24px" }) => {
  return <div style={styles.space(height)} />;
};

export default WhiteSpace;
